import { useCampaignListingByType, ICampaignType } from '~/modules/campaign';
import { useCGTemplateListing } from '~/modules/campaign-group-template';
import { useCampaignTemplateListing } from '~/modules/campaign-template';
import { mapByKey } from '~/utils';
import { useMemo } from 'react';

export const useCampaignMaps = () => {
  const campaignListing = useCampaignTemplateListing();
  const campaignPriceListing = useCampaignListingByType(ICampaignType.PRICE);
  const campaignUrlListing = useCampaignListingByType(ICampaignType.URL);
  const campaignGroupTemplateListing = useCGTemplateListing();

  // Price and URL experiments are campaigns too, so they share the same map (and the same `experiment_id` filter)
  const campaignMap = useMemo(() => {
    return mapByKey(
      [...campaignListing.data, ...campaignPriceListing.data, ...campaignUrlListing.data],
      'id',
    );
  }, [campaignListing, campaignPriceListing, campaignUrlListing]);

  const campaignGroupMap = useMemo(() => {
    return mapByKey(campaignGroupTemplateListing.data, 'id');
  }, [campaignGroupTemplateListing]);

  return {
    campaignMap,
    campaignGroupMap,
  };
};
